/**
 * Утилита для поиска AI пресетов
 * Вынесено из legacy-app.js для модульности
 */

/**
 * Получает AI пресет по ID
 * Ищет пресет по различным критериям для совместимости
 * 
 * @param {string} presetId - ID пресета для поиска
 * @param {array} battleAiTemplates - Массив AI пресетов из BATTLE_AI_TEMPLATES
 * @returns {object|null} Найденный пресет или null
 */
export function findAiPreset(presetId, battleAiTemplates) {
  if (!presetId || !Array.isArray(battleAiTemplates)) {
    return null;
  }
  
  // Пробуем найти пресет по точному совпадению ID
  let preset = battleAiTemplates.find(t => t.id === presetId);
  if (preset) return preset;
  
  // Если не найден, пробуем найти по baseId
  preset = battleAiTemplates.find(t => t.combatant?.baseId === presetId);
  if (preset) return preset;
  
  // Если не найден, пробуем найти с префиксом 'ai_'
  if (!presetId.startsWith('ai_')) {
    preset = battleAiTemplates.find(t => t.id === `ai_${presetId}`);
    if (preset) return preset;
  }
  
  // Если не найден, пробуем найти по типу существа (для совместимости)
  const typePresets = battleAiTemplates.filter(t => {
    const types = t.combatant?.creature?.types || [];
    return types.includes(presetId.toLowerCase());
  });
  
  if (typePresets.length > 0) {
    // Возвращаем первый найденный пресет с таким типом
    return typePresets[0];
  }
  
  return null;
}











